import React, { useState, useEffect } from 'react'
import { Spinner }                    from '@components/Spinner/Spinner'
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
import Combobox                       from '@react/shared/combobox'

export default function NewProductPriceForm({
  template, onProductSelect, onSubmit, onCancel
}) {
  const [salePrice, setSalePrice] = useState('')
  const [discount,  setDiscount]  = useState('')

  // when template loads, prefill the client price if available
  useEffect(() => {
    if (template?.sale_price?.amount != null) {
      setSalePrice(template.sale_price.amount)
    }
    setDiscount(template?.discount ?? '')
  }, [template])

  return (
    <>
      {/* 1. Ref */}
      <div className="pl-2">
        {template?.product && (
          <a
            data-toggle="modal"
            data-target="#remote-modal"
            data-action="click->modal#show"
            data-route={template.product.path}
          >
            {template.product.ref_brand}
          </a>
        )}
      </div>

      {/* 2. Combobox (select product) */}
      <div className="pl-2">
        <Combobox
          identifier       = "id"
          feed             = "/products/autocomplete.json"
          onSelectElement  = {item => onProductSelect(item.id)}
          placeholder      = {I18n.t("workorders.minimum_2_characters")}
          inputStyle       = {{ fontSize: '1rem' }}
          required
        />
      </div>

      {/* 3. Unit */}
      <div className="text-center">
        {template?.product?.unit || ''}
      </div>

      {/* 4. Purchase price */}
      <div className="text-right pr-2">
        {template?.purchase_price?.amount ?? ''}
      </div>

      {/* 5. Catalogue price */}
      <div className="text-right pr-2">
        {template?.sale_price?.amount ?? ''}
      </div>

      {/* 6. Client price input */}
      <div className="text-right pr-2">
        {template?.product && (
          <input
            className="form-control text-right"
            type="number"
            step="0.01"
            value={salePrice}
            onChange={e => setSalePrice(e.target.value)}
          />
        )}
      </div>

      {/* 7. Discount input */}
      <div className="text-right pr-2">
        {template?.product && (
          <input
            className="form-control text-right"
            type="number"
            step="0.01"
            value={discount}
            onChange={e => setDiscount(e.target.value)}
          />
        )}
      </div>

      {/* 8. Actions */}
      <div className="text-center">
        <span className="icon-wrapper" onClick={onCancel}>
          <FontAwesomeIcon icon="times-circle" />
        </span>

        {template?.product && (
          <span className="icon-wrapper">
            <button
              className="btn-link ml-0 save"
              onClick={() => onSubmit(Number(salePrice), discount)}
              disabled={!salePrice}
            >
              <FontAwesomeIcon icon="check-circle" />
            </button>
          </span>
        )}
      </div>
    </>
  )
}
